export enum UgovorTabEnum {
  Podugovori = 'podugovori',
  Korekcije = 'korekcije',
  CiljneGrupe = 'ciljneGrupe',
  Spotovi = 'spotovi',
  KlijentiBudzet = 'klijentiBudzet',
  AneksiUgovora = 'aneksiUgovora',
  AneksiPodugovora = 'aneksiPodugovora'
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/ugovori/enums/ugovor-tab.enum.ts